import { makeAutoObservable } from 'mobx'

export class Discount {
  name
  discount

  constructor(name, discount) {
    makeAutoObservable(this)
    this.name = name
    this.discount = discount
  }
}
export class DiscountRule {
  Amount
  IsPercent
  Id

  constructor({ Amount = null, IsPercent = null, Id = null } = {}) {
    makeAutoObservable(this)
    this.Amount = Amount
    this.IsPercent = IsPercent
    this.Id = Id
  }
}
